import * as types from "./mutation-types";
export default {
  [types.SET_COTATION](state, payload) {
    state.currentCotation = Object.assign(state.currentCotation, payload);
  },
  [types.REINIT_COTATION](state) {
    state.currentCotation.items = [];
  },
  [types.FILL_COTATION](state, payload) {
    state.currentCotation.items = payload.items;
  },
  [types.SET_MENU_FILTER] (state, payload) {
      state.menus = payload
  },
  [types.SET_FILTER_S_F](state, payload) {
      state.filters = Object.assign(state.filters, payload);
  },
  [types.REINIT_S_F](state) {
      state.filters.sf = [];
  },
};
